module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-wallet-add-cost"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Amount"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.amount),
      expression: "body.amount"
    }],
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.body.amount)
    },
    on: {
      "keypress": function($event) {
        return _vm.isNumber(_vm.event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "amount", $event.target.value)
      }
    }
  }), _c('label', [_vm._v("Included vat  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vat),
      expression: "vat"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.vat) ? _vm._i(_vm.vat, null) > -1 : (_vm.vat)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.vat,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.vat = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.vat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.vat = $$c
        }
      }
    }
  })])]), _c('div', {
    staticClass: "help-text"
  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.recordAmount)) + " included vat")])]), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Tax"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.tax),
      expression: "body.tax"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "tax", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select vat")]), _vm._l((_vm.vats), function(vat) {
    return _c('option', {
      domProps: {
        "value": vat.percentage / 100
      }
    }, [_vm._v(_vm._s(vat.description) + " (" + _vm._s(vat.name) + " " + _vm._s(vat.percentage) + "%)")])
  })], 2)]), _c('label', [_vm._v("Reason"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.reason),
      expression: "body.reason"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "reason", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "row column"
  }, [_c('ActionButton', {
    attrs: {
      "action": _vm.submit
    }
  }, [_vm._v("Add to wallet")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ded38424!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/WalletAddCost.vue
// module id = 2654
// module chunks = 1